import React, { FC } from 'react';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import Spacer from '@fenderdigital/ui/Spacer';
import PlaceHolder from '@fenderdigital/ui/Skeleton';
import HorizontalRule from '@fenderdigital/ui/HorizontalRule';
import Flex from '@fenderdigital/ui/Flex';
import Filter from '@fenderdigital/ui/Icons/Filter';

const ResultsContainer = styled.div`
  height: 100%;
  overflow-y: hidden;
  padding: 2rem 1rem 1rem 1rem;
  max-width: 23.9375rem;

  ${up('tablet-portrait')} {
    height: calc(100% - 4.938rem);
  }
`;

const FilterIcon = styled(Filter)`
  fill: #c4c4c4 !important;
  width: 1.1rem;
  height: 1.1rem;
`;

const LoadingPlaceholder: FC = () => (
  <ResultsContainer>
    <PlaceHolder>
      <PlaceHolder.Text width="12.5rem" height="2rem" lines={1} />
      <Spacer spacing="md2" />
      <Flex justify="space-between" align="center">
        <FilterIcon />
        <PlaceHolder.Text width="5.875rem" height="2rem" lines={1} />
        <PlaceHolder.Text width="5.875rem" height="2rem" lines={1} />
        <PlaceHolder.Text width="5.875rem" height="2rem" lines={1} />
      </Flex>
      <Spacer spacing="md4" />
      <PlaceHolder.Text width="8.125rem" height="1.375rem" lines={1} />
      <Spacer spacing="sm3" />
      <Flex justify="space-between">
        <PlaceHolder.Text
          width="10.438rem"
          height="5.875rem"
          lines={1}
          css={`
            border-radius: 0.2rem;
          `}
        />
        <Flex direction="column" justify="center">
          <PlaceHolder.Text width="9.25rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <PlaceHolder.Text width="9.25rem" height="0.875rem" lines={1} />
        </Flex>
      </Flex>
      <Spacer spacing="md3" />
      <HorizontalRule ariaHidden />
      <Spacer spacing="md4" />
      <PlaceHolder.Text width="6.25rem" height="0.875rem" lines={1} />
      <Spacer spacing="md1" />
      <Flex justify="space-between">
        <PlaceHolder.Text
          width="3.875rem"
          height="3.875rem"
          lines={1}
          css={`
            border-radius: 0.3rem;
          `}
        />
        <Flex direction="column" justify="center">
          <PlaceHolder.Text width="16rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <PlaceHolder.Text width="9.25rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <Flex align="center" justify="flex-start">
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
            <Spacer spacing="sm2" direction="vertical" />
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
            <Spacer spacing="sm2" direction="vertical" />
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
          </Flex>
        </Flex>
      </Flex>
      <Spacer spacing="md2" />
      <Flex justify="space-between">
        <PlaceHolder.Text
          width="3.875rem"
          height="3.875rem"
          lines={1}
          css={`
            border-radius: 0.3rem;
          `}
        />
        <Flex direction="column" justify="center">
          <PlaceHolder.Text width="16rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <PlaceHolder.Text width="9.25rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <Flex align="center" justify="flex-start">
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
            <Spacer spacing="sm2" direction="vertical" />
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
            <Spacer spacing="sm2" direction="vertical" />
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
          </Flex>
        </Flex>
      </Flex>
      <Spacer spacing="md2" />
      <Flex justify="space-between">
        <PlaceHolder.Text
          width="3.875rem"
          height="3.875rem"
          lines={1}
          css={`
            border-radius: 0.3rem;
          `}
        />
        <Flex direction="column" justify="center">
          <PlaceHolder.Text width="16rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <PlaceHolder.Text width="9.25rem" height="0.875rem" lines={1} />
          <Spacer spacing="sm3" />
          <Flex align="center" justify="flex-start">
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
            <Spacer spacing="sm2" direction="vertical" />
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
            <Spacer spacing="sm2" direction="vertical" />
            <PlaceHolder.Text width="0.625rem" height="0.625rem" lines={1} />
          </Flex>
        </Flex>
      </Flex>
      <Spacer spacing="md2" />
      <HorizontalRule ariaHidden />
      <Spacer spacing="md4" />
      <PlaceHolder.Text width="6.25rem" height="0.875rem" lines={1} />
      <Spacer spacing="md1" />
      <Flex align="center" justify="flex-start">
        <PlaceHolder.Text width="3rem" height="3rem" lines={1} />
        <Spacer spacing="md3" direction="vertical" />
        <PlaceHolder.Text width="9.25rem" height="0.875rem" lines={1} />
      </Flex>
    </PlaceHolder>
  </ResultsContainer>
);

export default LoadingPlaceholder;
